<template src='./conciliationCritFields.pug' lang='pug'></template>

<script>
import vSelect from 'vue-select'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'

export default {
  name: 'ConciliationCritFields',

  components: {
    vSelect,
    ButtonPrimary
  },

  props: {
    conciliationField: {
      type: Object,
      default: {},
      required: true
    },
    attributesCfgMfList: {
      type: Array,
      default: () => [],
      required: true
    },
    attributesMfList: {
      type: Array,
      default: () => [],
      required: true
    },
    mfFieldList: {
      type: Array,
      default: () => [],
      required: true
    },
    mbFieldList: {
      type: Array,
      default: () => [],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    conciliationFieldList: {
      type: Array,
      default: () => [],
      required: true
    }
  },

  data () {
    return {
      field: {
        atributo: {
          nomeAtributo: null,
          atributoCfg: null
        }
      }
    }
  },

  computed: {
    mfCfgList () {
      let mfCfgList = []
      let self = this
      this.attributesCfgMfList.map(cfg => {
        // Campos de conciliacao so podem ser utilizados uma vez a menos que sejam dinamicos
        if (cfg.linkType === (self.conciliationField && self.conciliationField.conciliacaoCampoMovFinan ? self.conciliationField.conciliacaoCampoMovFinan.tipoVinculo : '')) {
          mfCfgList.push(cfg)
        }
      })
      return mfCfgList
    },

    mfAttList () {
      let attributesCfgMf = []
      let self = this
      this.attributesMfList.map(att => {
        let alreadyUsed = false
        // Campos de conciliacao so podem ser utilizados uma vez a menos que sejam dinamicos
        if (self.conciliationFieldList && self.conciliationFieldList.length > 0) {
          alreadyUsed = self.conciliationFieldList.findIndex(concField => {
            return (concField.key !== self.conciliationField.key) &&
              (concField.atributo && concField.atributo.nomeAtributo ? concField.atributo.nomeAtributo.id : null) === att.id &&
              (concField.conciliacaoCampoMovFinan ? concField.conciliacaoCampoMovFinan.id : null) === (self.conciliationField && self.conciliationField.conciliacaoCampoMovFinan ? self.conciliationField.conciliacaoCampoMovFinan.id : null)
          }) !== -1
        }
        if (!alreadyUsed) {
          attributesCfgMf.push(att)
        }
      })
      return attributesCfgMf
    }
  },

  watch: {
    conciliationField: {
      handler (newVal, oldVal) {
        this.field = {
          ...newVal,
          atributo: newVal.atributo
          ? {
            atributoCfg: newVal.atributo.atributoCfg ? {...newVal.atributo.atributoCfg} : null,
            nomeAtributo: newVal.atributo.nomeAtributo ? {...newVal.atributo.nomeAtributo} : null
          }
          : null
        }
      },
      deep: true
    }
  },

  methods: {
    changeMfField (field) {
      if (field === null || field instanceof Object) {
        this.$emit('change-conc-field-mf', { field, concField: this.conciliationField })
      }
    },

    changeMbField (field) {
      if (field === null || field instanceof Object) {
        this.$emit('change-conc-field-mb', { field, concField: this.conciliationField })
      }
    },

    changeMfAttCfg (cfg) {
      if (cfg === null || cfg instanceof Object) {
        this.$emit('change-conc-field-cfg-mf', { cfg, concField: this.conciliationField })
      }
    },

    updateMfAttList (cfg) {
      if (cfg === null || cfg instanceof Object) {
        this.$emit('update-attributes-list', { cfg, concField: this.conciliationField })
      }
    },

    changeMfAtt (att) {
      if (att === null || att instanceof Object) {
        this.$emit('change-conc-field-att-name-mf', { att, concField: this.conciliationField })
      }
    },

    removeField () {
      this.$emit('remove-field-from-criteria-concil', this.conciliationField)
    }
  },

  mounted () {
    this.field = {
      ...this.conciliationField,
      atributo: this.conciliationField.atributo
      ? {
        atributoCfg: this.conciliationField.atributo.atributoCfg ? {...this.conciliationField.atributo.atributoCfg} : null,
        nomeAtributo: this.conciliationField.atributo.nomeAtributo ? {...this.conciliationField.atributo.nomeAtributo} : null
      }
      : null
    }
    this.updateMfAttList(this.conciliationField.atributo && this.conciliationField.atributo.atributoCfg ? this.conciliationField.atributo.atributoCfg : null)
  }
}
</script>

<style scoped>
.info-text {
  color: #1d436a;
  font-size: 15px;
}

.info-icon-text {
  margin-right: 10px;
  color: #1d436a;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// ConciliationCritFields.vue?5233b109